<template>
  <v-list color="background-higher">
    <div class="d-flex justify-end pe-4 pt-2">
      <v-icon
        color="white"
        @click="$emit('close')"
        >fa-times-circle</v-icon
      >
    </div>
    <v-list-item
      style="background-color: var(--v-background-base); margin: 8px 10px; border-radius: 10px"
    >
      <v-list-item-content>
        <v-list-item-title class="white--text font-weight-bold">{{
          $t("menu.accessibility.fontSize")
        }}</v-list-item-title>
        <v-list-item-subtitle class="white--text">
          {{ textSize }}%
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          small
          fab
          color="be-error"
          @click="textResize('reduce')"
          :disabled="textSize == 100"
        >
          <v-icon
            x-small
            color="text-on-primary"
            class="me-n1"
            >fa-font</v-icon
          >
          <v-icon
            x-small
            color="text-on-primary"
            class="ms-n1"
            >fa-minus</v-icon
          >
        </v-btn>
      </v-list-item-action>
      <v-list-item-action>
        <v-btn
          small
          fab
          color="be-primary"
          @click="textResize('enlarge')"
          :disabled="textSize == 200"
        >
          <v-icon
            color="text-on-primary"
            class="ms-2 me-n2"
            >fa-font</v-icon
          >
          <v-icon
            x-small
            color="text-on-primary"
            >fa-plus</v-icon
          >
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <!-- <v-list-item
      style="background-color: var(--v-background-base); margin: 8px 10px; border-radius: 10px"
    >
      <v-list-item-content>
        <v-list-item-title class="text-on-background--text font-weight-bold">
          Alto Contraste
        </v-list-item-title>
        <v-list-item-subtitle class="white--text">
          
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          small
          fab
          :color="contrast === 'high' ? `error` : `success`"
          @click="contrastChange"
        >
          <v-icon
            color="text-on-primary"
            class=""
            >{{ contrast === 'high' ? `fa-times` : `fa-check` }}</v-icon
          >
        </v-btn>
      </v-list-item-action>
    </v-list-item> -->
    <div class="text-on-background--text d-flex justify-center">
      <a
        @click="restoreSettings('default')"
        style="color: var(--v-text-on-background-base); text-decoration: underline"
      >
        <v-icon
          small
          left
          color="text-on-background"
          >fa-sync</v-icon
        >
        {{ $t("menu.accessibility.restoreSettingsToDefault") }}</a
      >
    </div>
    <div
      v-if="userTextSize && userTextSize !== textSize"
      class="text-on-background--text d-flex justify-center"
    >
      <a
        @click="restoreSettings('preferences')"
        style="color: var(--v-text-on-background-base); text-decoration: underline"
      >
        <v-icon
          small
          left
          color="text-on-background"
          >fa-sync</v-icon
        >
        {{ $t("menu.accessibility.restoreSettingsToPreferences") }}</a
      >
    </div>
    <div
      v-if="textSize !== userTextSize"
      class="text-on-primary--text d-flex justify-center mt-4"
      style="padding: 0 10px"
    >
      <BeButton
        small
        theme="primary"
        @click="saveSettings"
      >
        <v-icon
          small
          left
          color="text-on-primary"
          >fa-user</v-icon
        >
        {{ $t("menu.accessibility.saveSettings") }}
      </BeButton>
    </div>
  </v-list>
</template>

<script>
import appApi from "@/plugins/api/api";
import BeButton from "be-components/components/Button";

export default {
  name: "AccessibilityOptions",
  components: {
    BeButton,
  },
  data() {
    return {
      savingPreferences: false,
      resettingPreferences: false,
      showRestoreOptions: true,
      highContrast: false,
    };
  },
  computed: {
    textSize() {
      return this?.$store?.state?.textSize;
    },
    userTextSize() {
      return this?.$store?.state?.userTextSize;
    },
    contrast() {
      return this?.$store?.state?.contrast;
    },
    userContrast() {
      return this?.$store?.state?.userContrast;
    }
  },
  methods: {
    textResize(action) {
      let newTextSize = this.textSize;
      switch (this.textSize) {
        case 100:
          newTextSize = 120;
          break;
        case 120:
          if (action == "reduce") {
            newTextSize = 100;
          } else {
            newTextSize = 150;
          }
          break;
        case 150:
          if (action == "reduce") {
            newTextSize = 120;
          } else {
            newTextSize = 200;
          }
          break;
        case 200:
          newTextSize = 150;
          break;
      }
      this.$store.commit("setCustomFontSize", newTextSize);
    },
    contrastChange() {
      let newContrast = this.contrast;
      switch (this.contrast) {
        case 'normal':
        newContrast = 'high';
        document.body.classList.add('high-contrast-settings');
          break;
        case 'high':
        newContrast = 'normal';
        document.body.classList.remove('high-contrast-settings')
        break;
      }
      this.$store.commit("setCustomContrast", newContrast);
    },
    restoreSettings(mode) {
      let newTextSize = mode === "preferences" ? this.userTextSize : 100;
      let newContrast = mode === "preferences" ? this.userContrast : 'normal';

      this.$store.commit("setCustomFontSize", newTextSize);
      this.$store.commit("setCustomContrast", newContrast);
    },
    saveSettings() {
      let preferences = {
        textSize: this.textSize,
        contrast: this.contrast,
      };
      this.savingPreferences = true;
      appApi
        .putUserAccessibilityPreferences(preferences)
        .then((res) => {
          this.$store.commit("setCustomFontSize", this.textSize);
          this.$store.commit("linkFontSizeToUser", "link");
          this.$root.$emit("globalSnackbar", {
            show: true,
            text: this.$t("comuns.saveSuccess"),
            color: "#27AE60",
            timeout: 2000,
          });
        })
        .catch(() => {
          this.$root.$emit("globalSnackbar", {
            show: true,
            text: this.$t("comuns.saveError"),
            color: "#FF5252",
            timeout: 2000,
          });
        })
        .finally(() => {
          this.savingPreferences = false;
        });
    },
  },
};
</script>

<style></style>
